import {
  Container,
  Flex,
  Box,
  Heading,
  IconButton,
  Button,
  VStack,
  HStack,
  useColorModeValue
} from '@chakra-ui/react';
import {
  MdPhone,
  MdEmail,
  MdLocationOn,
  MdFacebook,
} from 'react-icons/md';
import { BsGithub, BsLinkedin } from 'react-icons/bs';

export default function Contact() {
  return (
    <Container
      justifyContent={'center'} id='contact' bg={useColorModeValue('gray.50', 'gray.800')} maxW="full" mt={{ base: 20, lg: 0 }} centerContent overflow="hidden" borderRadius={'2xl'}
      py={{ base: '15%', sm: '10%', lg: 0 }}
      >
      <Flex>
        <Box
          boxShadow={'2xl'}
          bg="white"
          color="white"
          borderRadius="10%"
          m={{ sm: 4, md: 16, lg: 10 }}
          py={'7%'}>
          <Box>
            <Heading
              textAlign={'center'} color={'teal.300'}>Contact</Heading>
            <Box py={{ base: 5, sm: 5, md: 8, lg: 10 }}>
              <VStack spacing={3} alignItems="center">

                <Button
                  size="md"
                  height="48px"
                  width="300px"
                  variant="ghost"
                  color="black"
                  leftIcon={<MdEmail color="#4FD1C5" size="20px" />}>
                  villanuevaraul992@gmail.com
                </Button>
                <Button
                  size="md"
                  height="48px"
                  width="200px"
                  variant="ghost"
                  color="black"
                  leftIcon={<MdLocationOn color="#4FD1C5" size="20px" />}>
                  Masbate City, Philippines
                </Button>
                <Button
                  size="md"
                  height="48px"
                  width="200px"
                  variant="ghost"
                  color="black"
                  leftIcon={<MdPhone color="#4FD1C5" size="20px" />}>
                  +9618092216
                </Button>
              </VStack>
            </Box>
            <HStack
              spacing={5}
              px={5}
              justifyContent='center'>

              <a href='https://www.facebook.com/Villanueva321'>
                <IconButton
                  aria-label="facebook"
                  color="teal.300"
                  size="lg"
                  isRound={true}
                  _hover={{
                    bg: 'grey',
                    transform: 'translateY(-5px)',
                    boxShadow: 'lg'
                  }}
                  icon={<MdFacebook size="28px" />}
                />
              </a>

              <a href="https://github.com/Villanueva0909">
                <IconButton
                  aria-label="github"
                  color="teal.300"
                  size="lg"
                  isRound={true}
                  _hover={{
                    bg: 'grey',
                    transform: 'translateY(-2px)',
                    boxShadow: 'lg'
                  }}
                  icon={<BsGithub size="28px" />}
                />
              </a>

              <a href='https://www.linkedin.com/in/raul-iii-villanueva-139979219/'>
                <IconButton
                  aria-label="BsLinkedin"
                  color="teal.300"
                  size="lg"
                  isRound={true}
                  _hover={{
                    bg: 'grey',
                    transform: 'translateY(-2px)',
                    boxShadow: 'lg'
                  }}
                  icon={<BsLinkedin size="28px" />}
                />
              </a>

            </HStack>
          </Box>
        </Box>
      </Flex>
    </Container>
  );
}